import { render, staticRenderFns } from "./editBasketballRate.vue?vue&type=template&id=6044a694&scoped=true&"
import script from "./editBasketballRate.vue?vue&type=script&lang=js&"
export * from "./editBasketballRate.vue?vue&type=script&lang=js&"
import style0 from "./editBasketballRate.vue?vue&type=style&index=0&id=6044a694&prod&lang=css&"
import style1 from "./editBasketballRate.vue?vue&type=style&index=1&id=6044a694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044a694",
  null
  
)

export default component.exports